<div class="py-20 relative z-20">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
      <!-- Card -->
      <div
        class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
      >
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <i class="fa-solid fa-chart-line text-4xl icon-gradient mb-4 relative z-10"></i>
        <div class="text-3xl font-semibold text-text-primary mb-2 relative z-10 group-hover:icon-gradient transition-all duration-300">12,000+</div>
        <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">{{ 'about.statistics.properties' | translate }}</div>
      </div>

      <!-- Card -->
      <div
        class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
      >
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <i class="fa-solid fa-users text-4xl icon-gradient mb-4 relative z-10"></i>
        <div class="text-3xl font-semibold text-text-primary mb-2 relative z-10 group-hover:icon-gradient transition-all duration-300">15,000+</div>
        <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">{{ 'about.statistics.customers' | translate }}</div>
      </div>

      <!-- Card -->
      <div
        class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
      >
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <i class="fa-solid fa-award text-4xl icon-gradient mb-4 relative z-10"></i>
        <div class="text-3xl font-semibold text-text-primary mb-2 relative z-10 group-hover:icon-gradient transition-all duration-300">8,500+</div>
        <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">{{ 'about.statistics.deals' | translate }}</div>
      </div>

      <!-- Card -->
      <div
        class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
      >
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <i class="fa-solid fa-shield-halved text-4xl icon-gradient mb-4 relative z-10"></i>
        <div class="text-3xl font-semibold text-text-primary mb-2 relative z-10 group-hover:icon-gradient transition-all duration-300">250+</div>
        <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">{{ 'about.statistics.partners' | translate }}</div>
      </div>
    </div>
  </div>
</div>
